import { Action } from "@ngrx/store";
import { ShoppingItem } from "../models/shopping-item.model";


export enum ShoppingActionTypes {
    ADD_ITEM = '[SHOPPING] Add Item',
    REMOVE_ITEM = '[SHOPPING] Remove Item',
    NEW_LIST = '[SHOPPING] New List',
    UPDATE_QUANTITY = '[SHOPPING] Update Quantity',
    GET_ITEM_BY_ID = '[SHOPPING] Get Item By Id',
    UPDATE_NOTIFICATIONS = '[LOGIN] Update Notifications'
}

export class AddItemAction implements Action {
    readonly type = ShoppingActionTypes.ADD_ITEM;

    constructor(public payload: ShoppingItem) {}
}

export class RemoveItemAction implements Action {
    readonly type = ShoppingActionTypes.REMOVE_ITEM;

    constructor(public payload: ShoppingItem) {}
}

export class NewListAction implements Action {
    readonly type = ShoppingActionTypes.NEW_LIST;

    constructor(public payload: ShoppingItem[]) {}
}

export class UpdateQuantityAction implements Action {
    readonly type = ShoppingActionTypes.UPDATE_QUANTITY;

    constructor(public payload: ShoppingItem) {}
}

export class GetItemByIdAction implements Action {
    readonly type  = ShoppingActionTypes.GET_ITEM_BY_ID;

    constructor(public payload: string) {}
}

export class UpdateNotifications implements Action {
    readonly type  = ShoppingActionTypes.UPDATE_NOTIFICATIONS;

    constructor(public payload: number) {}
}


export type ShoppingAction = AddItemAction | RemoveItemAction | NewListAction | UpdateQuantityAction | UpdateNotifications
